import React from "react";
import Flagship from "../../core/flagship";
import { connect } from "react-redux";
import { Card, Button, Header } from "semantic-ui-react";
import { Link } from "react-router";
import "../../styles/dashboard.scss";

class Admin extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    setTimeout(Flagship.closeSidebarNav, 500);
  }

  componentDidMount() {
    document.title = "Flagship / Admin";
  }

  render() {
    if (this.props.userRole === "admin") {
      return (
        <div className="fade-in">
          <Header as="h1" className="white-text">
            Administration
          </Header>
          <Card.Group>
            <Card>
              <Card.Content>
                <Card.Header>Users</Card.Header>
                <Card.Meta>Manage user accounts and permissions.</Card.Meta>
              </Card.Content>
              <Card.Content extra>
                <Button>Edit Users</Button>
              </Card.Content>
            </Card>
            <Card>
              <Card.Content>
                <Card.Header>Fields</Card.Header>
                <Card.Meta>
                  Manage form fields used throughout Flagship.
                </Card.Meta>
              </Card.Content>
              <Card.Content extra>
                <Link to="/admin/fields">
                  <Button>Edit Fields</Button>
                </Link>
              </Card.Content>
            </Card>
          </Card.Group>
          <div id="footer">Flagship Administration</div>
        </div>
      );
    } else {
      return (
        <div className="fade-in">
          <Header as="h1" className="white-text">
            Administration
          </Header>
          <p className="white-text">
            You do not have access to administer Flagship.
          </p>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    firstName: state.main.userFirstName,
    userRole: state.main.userRole,
    userId: state.main.userId
  };
}

export default connect(mapStateToProps, null)(Admin);



// WEBPACK FOOTER //
// ./src/components/views/Admin.js